export function getTurnList(data) {
    let { getTurnListRequest, getTurnListError, getTurnListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_turn_list',
        this.createBundle('get_turn_list', { data: data }, this.GET, getTurnListRequest, getTurnListResult, getTurnListError)
    )
}
